import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

import NavigationMenu from './NavigationMenu';
import NavigationMenuMobile from './NavigationMenuMobile';
import FooterComponent from './FooterComponent';
import LiveChat from '../common/LiveChat';
import CookieConsent from '../common/CookieConsent';
import { useNavigation } from '../../context/NavigationContext';

const Layout = ({ children, pageSectionRefsContainer }) => {
  const location = useLocation();
  const { startPageTransition } = useNavigation();

  const getNavTextColor = () => {
    if (location.pathname === '/') {
      return '#ffffff';
    }
    return '#000000';
  };

  const shouldHideFooter = () => {
    return location.pathname === '/';
  };

  const isHomePage = location.pathname === '/';
  const navWidth = 225;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Desktop Navigation */}
      <NavigationMenu
        pageSectionRefsContainer={pageSectionRefsContainer}
        textColor={getNavTextColor()}
        width={navWidth}
        isHomePage={isHomePage}
      />
      
      {/* Mobile Navigation */}
      <NavigationMenuMobile
        textColor={getNavTextColor()}
        isHomePage={isHomePage}
        pageSectionRefsContainer={pageSectionRefsContainer}
        startPageTransition={startPageTransition}
      />
      
      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          position: 'relative',
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            boxSizing: 'border-box'
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: isHomePage ? '100%' : '1400px',
              px: isHomePage ? 0 : {
                xs: 2,
                sm: 4,
                md: 5,
                lg: 6,
                xl: 8
              },
              pr: {
                xs: 2,
                sm: 4,
                md: `calc(${navWidth}px + 40px)`,
                lg: `calc(${navWidth}px + 48px)`,
                xl: `calc(${navWidth}px + 64px)`
              },
              pt: isHomePage ? 0 : { xs: 3, md: 5 },
              pb: isHomePage ? 0 : 6,
              boxSizing: 'border-box'
            }}
          >
            <Box sx={{ flexGrow: 1 }}>{children}</Box>
          </Box>
        </Box>
      </Box>
      
      {!shouldHideFooter() && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            boxSizing: 'border-box'
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: '1400px',
              px: {
                xs: 2,
                sm: 4,
                md: 5,
                lg: 6,
                xl: 8
              },
              pr: {
                xs: 2,
                sm: 4,
                md: `calc(${navWidth}px + 40px)`,
                lg: `calc(${navWidth}px + 48px)`,
                xl: `calc(${navWidth}px + 64px)`
              },
              boxSizing: 'border-box'
            }}
          >
            <FooterComponent />
          </Box>
        </Box>
      )}
      
      {/* LiveChat Widget - Available on all pages except home */}
      <LiveChat />
      
      {/* Cookie Consent Banner */}
      <CookieConsent />
    </Box>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  pageSectionRefsContainer: PropTypes.object
};

export default Layout;
